import { apiFetch } from "@/lib/api";

export type Transfer = {
  id: number;
  transfer_code: string;
  emirate: string;
  title: string;
  description?: string | null;
  type: string;
  pricing_type: string;
  capacity?: number | null;
  price_op?: number | null;
  price_ag?: number | null;
  price_cf?: number | null;
  supplier_name?: string | null;
  cost_supplier?: number | null;
  tax_percentage?: number | null;
  hcte_notes?: string | null;
  image_url?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type TransferListItem = {
  id: number;
  transfer_code: string;
  emirate: string;
  title: string;
  type: string;
  capacity?: number | null;
};

export type TransferListResponse = {
  items: TransferListItem[];
  total: number;
};

export const fetchTransfers = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<TransferListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<TransferListResponse | null>(`/transfers?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getTransfer = async (id: number): Promise<Transfer> => {
  return apiFetch<Transfer>(`/transfers/${id}`);
};

export const createTransfer = async (data: Partial<Transfer>): Promise<Transfer> => {
  return apiFetch<Transfer>("/transfers", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createTransferAllowDuplicates = async (data: Partial<Transfer>): Promise<Transfer> => {
  return apiFetch<Transfer>("/transfers?allow_duplicates=true", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateTransfer = async (id: number, data: Partial<Transfer>): Promise<Transfer> => {
  return apiFetch<Transfer>(`/transfers/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteTransfer = async (id: number): Promise<void> => {
  await apiFetch<void>(`/transfers/${id}`, { method: "DELETE" });
};

export const deleteAllTransfers = async (): Promise<void> => {
  await apiFetch<void>("/transfers", { method: "DELETE" });
};
